import { ApiProperty } from "@nestjs/swagger";
import { ItemResponsibleEnum, SalesPersonEnum, StatusEnum } from "@project-management-system/shared-models";

export class SamplecoLineDto {

  
    @ApiProperty()
    buyerPo: string;

    @ApiProperty()
    buyerCode: string;

    @ApiProperty()
    buyerAddress: string;

    @ApiProperty()
    deliveryDate: string;
    
    @ApiProperty()
    itemNo: string;

    @ApiProperty()
    salesPerson: SalesPersonEnum;
    
    @ApiProperty()
    itemResponsible?: ItemResponsibleEnum;

    @ApiProperty()
    shipmentType: string;

    @ApiProperty()
    agent: string;

    @ApiProperty()
    orderQty: string;

    @ApiProperty()
    salesPrice: string;

    @ApiProperty()
    status: StatusEnum;

    @ApiProperty()
    errorMsg: string

    @ApiProperty()
    coNumber: string

    @ApiProperty()
    coDate: string

    @ApiProperty()
    buyerStyle ?: string

    @ApiProperty()
    itemDescription ?: string

    @ApiProperty()
    deliveryAddress: string;
 
    
}
